import { FC, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarPurchasesApi } from "../../http/carPurchases/api";
import Header from "../ui/Header";
import Panel from "../ui/Panel";
import CarPurchaseForm, { CarPurchaseFormBody } from "./CarPurchaseForm";

const NewCarPurchase: FC = () => {
  const navigate = useNavigate();
  const i18n = useI18n();
  const carPurchasesApi = useCarPurchasesApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async function (data: CarPurchaseFormBody) {
    const param = new URLSearchParams(window.location.search);
    const carPlanningId = param.get("car_planning_id");

    setIsSubmitting(true);
    try {
      const response = await carPurchasesApi.insertAdminCarPurchase({
        subsidiaryId: data.subsidiary.id,
        supplierId: data.supplier?.id,
        leasingCompanyId: data.leasingCompany?.id,
        driverId: data.driver?.id,
        manufacturerId: data.manufacturer.id,
        model: data.model,
        plannedArrivalDate: data.plannedArrivalDate,
        purchaseDate: data.purchaseDate,
        costNet: data.costNet,
        costGross: data.costGross,
        currency: data.currency?.value,
        state: data.state.value,
        optionals: data.optionals,
        purchaseType: data.purchaseType.value,
        carPlanningId: carPlanningId,
      });
      dispatch(showSuccessNotification(i18n.t));
      navigate(`/admin/car_purchases/${response.id}`);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header title={i18n.t.carOrders.new} />
      <Panel>
        <CarPurchaseForm onSubmit={onSubmit} isDisabled={isSubmitting}></CarPurchaseForm>
      </Panel>
    </>
  );
};

export default NewCarPurchase;
